(function () {
  function run() {
    if (typeof IntersectionObserver === "undefined") {
      return;
    }

    let hasUserInteracted = false;

    const isTouch =
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0 ||
      "orientation" in window ||
      /\b(BlackBerry|webOS|iPhone|IEMobile|Android|Windows Phone|iPad|iPod)\b/i.test(
        navigator.userAgent
      );

    const showControlsOnTap =
      window.instavidSettings &&
      window.instavidSettings.showControlsOnTap &&
      !isTouch;
    const shouldPermanentlyHideControls =
      window.instavidSettings &&
      window.instavidSettings.hideControls &&
      !(isTouch && window.instavidSettings.showControlsOnTap); // don't hide if mobile and show on tap
    const shouldTemporarilyHideControls =
      window.instavidSettings &&
      window.instavidSettings.hideControls &&
      isTouch &&
      window.instavidSettings.showControlsOnTap;
    const inlineVideoOnMobile =
      window.instavidSettings && window.instavidSettings.inlineVideoOnMobile;

    function interactionListener(evt) {
      if (!evt.isTrusted) {
        return;
      }
      hasUserInteracted = true;
      document.removeEventListener("click", interactionListener);
    }
    document.addEventListener("click", interactionListener);

    // flickity and some themes disable scrolling carousels when video is playing
    document.addEventListener(
      "theme:media:play",
      function (evt) {
        setTimeout(function () {
          if (!evt.target) {
            return;
          }

          evt.target.dispatchEvent(new CustomEvent("theme:media:pause"));
        }, 10);
      },
      { capture: true }
    );

    function setUpVideoElementToAutoplay(target, forceMute) {
      if (!hasUserInteracted || forceMute) {
        target.defaultMuted = true;
        target.muted = true;
      }

      target.playsInline = true;

      if (shouldTemporarilyHideControls) {
        target.controls = false;
        setTimeout(function () {
          target.controls = true;
        }, 20);
      } else if (shouldPermanentlyHideControls) {
        target.controls = false;

        // handle plyr
        const grandparent =
          target.parentElement && target.parentElement.parentElement;
        if (
          grandparent &&
          grandparent.matches &&
          grandparent.matches(".plyr")
        ) {
          const controls = grandparent.querySelector(".plyr__controls");
          if (controls) {
            controls.style.display = "none";
          }
        }
      }

      if (window.instavidSettings) {
        target.loop = window.instavidSettings.loop;
      }
    }

    function setUpVideoToAutoplay(target) {
      if (!target) {
        return;
      }

      if (target.nodeName === "VIDEO") {
        setUpVideoElementToAutoplay(target);
        return;
      }

      // shopify default theme uses a template and button instead of direct video element
      const template = target.getElementsByTagName("template")[0];
      if (!template) {
        return;
      }

      const iframe = template.content.querySelector("iframe");
      if (iframe) {
        // youtube video - must be muted
        const src = new URL(iframe.src);
        src.searchParams.set("rel", "0");
        src.searchParams.set("autoplay", "1");
        if (!hasUserInteracted) {
          src.searchParams.set("mute", "1");
        }
        if (window.instavidSettings && window.instavidSettings.hideControls) {
          src.searchParams.set("controls", "0");
          src.searchParams.set("modestbranding", "1");
        }
        if (window.instavidSettings && window.instavidSettings.loop) {
          src.searchParams.set("loop", "1");
        }
        iframe.src = src.toString();

        return;
      }

      const video = template.content.querySelector("video");
      if (!video) {
        return;
      }

      setUpVideoElementToAutoplay(video);
    }

    const hasPlayed = new Set();

    function handleIntersection(entries) {
      const obs = this;
      const len = entries.length;
      for (let i = 0; i < len; ++i) {
        const entry = entries[i];
        if (entry.isIntersecting && !isHidden(entry.target)) {
          setUpVideoToAutoplay(entry.target);
          if (entry.target.nodeName === "VIDEO") {
            const p = entry.target.play().catch(() => {
              // iOS refuses to play video even if the user interacted with the page unless it's muted
              setUpVideoElementToAutoplay(entry.target, true);
              entry.target.play();
            });
          } else if (entry.target.nodeName === "DEFERRED-MEDIA") {
            const mediaId = entry.target.getAttribute("data-media-id");
            if (mediaId && hasPlayed.has(mediaId)) {
              continue;
            }
            hasPlayed.add(mediaId);
            const target = entry.target;
            const button = target.getElementsByTagName("button")[0];
            const video = target.getElementsByTagName("video")[0];
            if (button && !video) {
              button.click();
              setTimeout(function() {
                // iOS just refuses to auto-play videos without a click...
                const video = target.getElementsByTagName("video")[0];
                if (video) {
                  video.play();
                }
              }, 40)
            }
            if (shouldTemporarilyHideControls) {
              setTimeout(function () {
                const video = entry.target.getElementsByTagName("video")[0];
                if (video) {
                  video.controls = true;
                }
              }, 40);
            }
          }

          obs.unobserve(entry.target);
        }
      }
    }

    const obsByScrollableAncestor = new Map();
    obsByScrollableAncestor.set(null, new IntersectionObserver(handleIntersection, {
      threshold: 0.25,
    }));

    function watchElements(els) {
      const len = els.length;
      for (let i = 0; i < len; ++i) {
        const el = els[i];

        if (inlineVideoOnMobile) {
          const mediaId = el.getAttribute("data-media-id");
          if (mediaId) {
            // on mobile, deferred-media is hidden and video plays in a popup.
            // we don't want that
            el.style.display = "block";
            el.style.width = "100%";
            const openerBtn = document.querySelector(
              `modal-opener button[data-media-id="${mediaId}"]`
            );
            if (openerBtn) {
              openerBtn.parentElement.style.display = "none";
            }
          }
        }

        const scrollableAncestor = getScrollableAncestor(el);
        const obs = obsByScrollableAncestor.get(scrollableAncestor) || new IntersectionObserver(handleIntersection, {
          root: scrollableAncestor,
          threshold: 0.25,
        });
        obsByScrollableAncestor.set(scrollableAncestor, obs);
        obs.observe(el);
      }
    }

    function handleControls() {
      if (!shouldPermanentlyHideControls || !showControlsOnTap) {
        return;
      }

      const videosWithControls = new Set();

      document.addEventListener("click", function (evt) {
        if (!evt || !evt.target || !evt.isTrusted) {
          return;
        }

        for (let video of videosWithControls) {
          if (video !== evt.target) {
            video.controls = false;
          }
        }

        videosWithControls.clear();

        const video = evt.target;
        if (video.nodeName === "VIDEO") {
          videosWithControls.add(evt.target);
          setTimeout(function () {
            // setTimeout so we don't pause playback from the first tap
            video.controls = true;
          }, 10);
        }
      });
    }

    handleControls();

    watchElements(document.getElementsByTagName("deferred-media"));
    watchElements(document.getElementsByTagName("video"));

    const deferredMedia =
      typeof window.customElements !== "undefined" &&
      typeof window.customElements.get === "function" &&
      window.customElements.get("deferred-media");
    if (deferredMedia) {
      // default theme only plays one video at a time
      deferredMedia.prototype.pauseAllMedia = function () {};
      // some theme versions use a global function
      if (typeof window.pauseAllMedia === "function") {
        window.pauseAllMedia = function () {};
      }
    }
  }

  function isHidden(el) {
    if (!el) {
      return false;
    }
    const styles = el.computedStyleMap();
    const directlyHidden =
      styles.get("display").value === "none" ||
      styles.get("visibility").value === "hidden";

    if (directlyHidden) {
      return true;
    }

    for (let pEl = el.parentElement; pEl; pEl = pEl.parentElement) {
      const styles = pEl.computedStyleMap();
      if (
        styles.get("display").value === "none" ||
        styles.get("visibility").value === "hidden"
      ) {
        return true;
      }
    }

    return false;
  }

  if (document.readyState === "loading") {
    window.addEventListener("DOMContentLoaded", function (event) {
      run();
    });
  } else {
    run();
  }
})();

function getScrollableAncestor(el) {
  if (!el) {
    return null;
  }

  for (let parent = el.parentElement; !!parent; parent = parent.parentElement) {
    const styles = parent.computedStyleMap();
    if (["scroll", "auto"].indexOf(styles.get("overflow-y").value) >= 0
      || ["scroll", "auto"].indexOf(styles.get("overflow-x").value) >= 0) {
      return parent;
    }
  }

  return null;
}